import React from "react";
import { Title } from "react-admin";
import Globe from "./components/Globe";
import MissionControlOverlay from "./components/MissionControlOverlay";

const MissionControl = (props) => {
  return (
    <div style={{ position: "relative" }}>
      <Title title="Mission Control" />

      <Globe />

      <MissionControlOverlay />
    </div>
  );
};

export default MissionControl;
